import React from "react";

/**
 * Official S&B Technologies logo (transparent PNG).
 */
export default function Logo({ size = "md", showWordmark = true, className = "" }) {
  const sizes = {
    sm: { mark: "h-12 w-12", word: "text-sm", sub: "text-[0.55rem]" },
    md: { mark: "h-16 w-16", word: "text-lg", sub: "text-[0.62rem]" },
    lg: { mark: "h-20 w-20", word: "text-xl", sub: "text-[0.65rem]" },
    xl: { mark: "h-28 w-28", word: "text-3xl", sub: "text-xs" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="sb-logo">
      <img
        src="/brand/sb-logo.png"
        alt="S&B Technologies"
        className={`${s.mark} object-contain shrink-0`}
        draggable={false}
      />
      {showWordmark && (
        <div className="flex flex-col leading-tight">
          <span className={`font-display font-semibold tracking-tight text-slate-900 ${s.word}`}>
            S&amp;B Technologies
          </span>
          <span className={`font-mono uppercase tracking-[0.22em] text-[#0066FF] ${s.sub}`}>
            Build · Acquire · Scale
          </span>
        </div>
      )}
    </div>
  );
}
